import React from 'react';

const steps = [
    {
        n: 1,
        title: 'Text us your content',
        desc: (
            <>
                Drop a message on WhatsApp at{' '}
                <a
                    href="https://wa.me/919413341382"
                    target="_blank"
                    rel="noreferrer"
                >
                    +91 94133 413 82
                </a>
                . Send a photo of the existing stamp, a sketch, or just type the lines —
                we will set it for you.
            </>
        ),
    },
    {
        n: 2,
        title: 'Pay via PayTM',
        desc: 'A clear estimate first — paper, ink, finish, quantity. Pay PayTM to 9413341382 once you are happy. No surprises at delivery.',
    },
    {
        n: 3,
        title: 'Pickup or get it delivered',
        desc: 'Collect from our office in Raja Park, or local delivery in Jaipur. Smell the ink before you sign.',
    },
];

function OrderStampSection() {
    return (
        <section id="stamp-section" className="bd-process">
            <div className="bd-process__disc" aria-hidden />

            <div className="bd-process__inner">
                <div>
                    <div className="bd-process__eyebrow">◆ 02 / Order stamps</div>
                    <h2 className="bd-process__h2">
                        Three steps,<br />
                        <em>no fuss.</em>
                    </h2>
                    <p className="bd-process__lede">
                        Need a rubber stamp made today? You don't need to come in — text, pay, pick up.
                        That's it.
                    </p>
                    <a
                        href="https://wa.me/919413341382"
                        target="_blank"
                        rel="noreferrer"
                        className="bd-btn bd-btn--accent"
                        style={{ marginTop: 32 }}
                    >
                        Start on WhatsApp <span aria-hidden>→</span>
                    </a>
                </div>

                <div className="bd-process__steps">
                    {steps.map((s) => (
                        <div key={s.n} className="bd-step">
                            <div className="bd-step__num">{s.n}</div>
                            <div>
                                <h3 className="bd-step__title">{s.title}</h3>
                                <p className="bd-step__desc">{s.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default OrderStampSection;
